import React from 'react';
import PropTypes from 'prop-types';
import { InningStateOverride } from '../PlayerDuel.style';

const BasePaths = ({
    first,
    second,
    third,
    width = 32,
    activeColor
}) => {
    return <InningStateOverride
        first={ first }
        second={ second }
        third={third}
        filledColor={activeColor}
        strokeColor={activeColor}
        emptyColor='transparent'
        rounded={false}
        basepathsWidth={ width }
        showCount={ false }
        showOutsText={true}
    />;
};

BasePaths.propTypes = {
    first: PropTypes.bool,
    second: PropTypes.bool,
    third: PropTypes.bool,
    width: PropTypes.number,
    activeColor: PropTypes.string
};

export default BasePaths;
